import React, { useEffect, useRef } from 'react';
import { animated, useSprings } from 'react-spring';
import { casesList } from './config';
import cx from 'classnames';
import { debounce } from 'lodash';

export default function CasesSwitch(props: {
    selectIndex: number;
    setSelectIndex: (i: number) => any;
}) {
    const { selectIndex, setSelectIndex } = props;

    const wrapperRef = useRef<HTMLDivElement>(null);
    const afterList = casesList.slice(selectIndex).concat(casesList.slice(0, selectIndex));
    function springsFn(selectIndex: number) {
        return (index: number) => {
            const wrapWith = wrapperRef.current?.clientWidth || 1300;
            const perOffsetX = wrapWith / casesList.length;

            const order = afterList.findIndex((item) => item.key === index);

            return {
                opacity: 0.7,
                top: 0,
                left: order * perOffsetX + 20,
            };
        };
    }
    const [springs, setTransition] = useSprings(casesList.length, springsFn(selectIndex));

    useEffect(() => {
        //@ts-expect-error
        setTransition(springsFn(selectIndex));
    }, [selectIndex]);
    useEffect(() => {
        const fix = debounce(() => {
            //@ts-expect-error
            setTransition(springsFn(selectIndex));
        }, 500);
        window.addEventListener('resize', fix);
        return () => window.removeEventListener('resize', fix);
    }, [selectIndex]);

    return (
        <div className="cases-switch" ref={wrapperRef}>
            {springs.map((props, index) => {
                const isActive = index === selectIndex;
                const item = casesList[index];
                return (
                    <animated.div
                        style={props}
                        className={cx('card', {
                            current: isActive,
                        })}
                        key={index}
                        onClick={() => setSelectIndex(index)}
                    >
                        <img
                            className="logo"
                            src={item.icon[isActive ? 'hover' : 'normal']}
                            alt={item.title}
                        />
                    </animated.div>
                );
            })}
        </div>
    );
}
